import axios, { InternalAxiosRequestConfig, AxiosError } from 'axios';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

// Add a request interceptor to include the access token in all requests
apiClient.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error: AxiosError) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle token expiration
apiClient.interceptors.response.use(
    (response) => response, // Pass through successful responses
    (error: AxiosError) => {
        if (error.response?.status === 401) {
            // The backend has confirmed the token is invalid or expired
            console.error("Authentication error: Token is invalid or expired.", error.response.data);
            
            // Clear the user's session from the frontend
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');

            // Force a full page reload. This will clear all application state
            // and the AuthProvider will redirect the user to the login page.
            window.location.reload();
        }
        return Promise.reject(error);
    }
);

export default apiClient;
